import { Auth } from 'aws-amplify';
import { CognitoIdentityCredentials, config } from 'aws-sdk';
import { readWebsiteVariable } from './readWebsiteVariable';

const cognitoPoolId = readWebsiteVariable('REACT_APP_aws_user_pools_id');
const cognitoIdentityPoolId = readWebsiteVariable(
  'REACT_APP_aws_cognito_identity_pool_main_id'
);
const cognitoRegion = readWebsiteVariable('REACT_APP_aws_cognito_region');

const accessToken = async (): Promise<string> => {
  const jwtToken = await (await Auth.currentSession())
    .getAccessToken()
    .getJwtToken();
  return jwtToken;
};

export const setAWSCreds = async (): Promise<void> => {
  const session = await Auth.currentSession();
  const accessToken = session.getAccessToken();

  // check if creds are already set and still not expired
  const existingCreds = config.credentials as CognitoIdentityCredentials;
  if (existingCreds && !existingCreds.needsRefresh()) {
    // make sure the idToken used to generate creds has not been invalidated
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params = existingCreds.params as any;
    if (
      Object.values(params['Logins'])[0] === session.getIdToken().getJwtToken()
    ) {
      // valid creds are already in place
      return;
    }
  }

  console.log('getting new creds');
  // There is something wrong with the AWS types, thus forcing me to use the disable
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const credsRequestParams: any = {
    IdentityPoolId: cognitoIdentityPoolId,
    Logins: {
      [`cognito-idp.${cognitoRegion}.amazonaws.com/${cognitoPoolId}`]: session
        .getIdToken()
        .getJwtToken()
    },
    DurationSeconds: 3600
  };

  const groups = accessToken.payload['cognito:groups'];
  if (groups && groups.includes('superadmin')) {
    credsRequestParams.CustomRoleArn = `arn:aws:iam::${readWebsiteVariable(
      'REACT_APP_aws_account_id'
    )}:role/app_superadmin`;
  }
  const creds = new CognitoIdentityCredentials(credsRequestParams);
  config.credentials = creds;
};

export default accessToken;
